export const TABLE_NEW_ROWS_LIMIT = 200;

export const ANSWERS_MAX_BYTES = 262_144;

// The sheet and the server both decide with this one function, so they never disagree on the size.
// It counts UTF-8 bytes without encoding and stops at the limit: the server runs it on every save, on
// bodies up to the 50 MB express accepts. JSON.stringify escapes a lone surrogate, so every surrogate
// it emits comes in a pair.
export function exceedsAnswersMaxBytes(answers: unknown): boolean {
  const text: string | undefined = JSON.stringify(answers);
  if (text === undefined) return false;
  // A UTF-16 code unit never takes less than one UTF-8 byte.
  if (text.length > ANSWERS_MAX_BYTES) return true;
  let bytes = 0;
  for (let index = 0; index < text.length && bytes <= ANSWERS_MAX_BYTES; index += 1) {
    const code = text.charCodeAt(index);
    if (code < 0x80) bytes += 1;
    else if (code < 0x800) bytes += 2;
    else if (code >= 0xd800 && code <= 0xdbff) {
      bytes += 4;
      index += 1;
    } else bytes += 3;
  }
  return bytes > ANSWERS_MAX_BYTES;
}
